import { ButtonLinkVariant } from '@kanda-libs/ks-design-library';

export type Destination =
  | 'dashboard'
  | 'subscription'
  | 'contract'
  | 'premium_credit_enable'
  | 'premium_credit_disable';

export const DESTINATION_SELECT_PROPS = {
  name: 'destination',
  label: 'Login destination',
  placeholder: 'Select...',
  options: [
    {
      name: 'dashboard',
      value: 'dashboard',
    },
    {
      name: 'subscription',
      value: 'subscription',
    },
    {
      name: 'contract',
      value: 'contract',
    },
    {
      name: 'premium credit enable',
      value: 'premium_credit_enable',
    },
    {
      name: 'premium credit disable',
      value: 'premium_credit_disable',
    },
  ],
};

export const DESTINATION_SELECT_VALIDATION = {
  required: {
    value: true,
    message: 'Destination is required',
  },
};

export const COPY_BUTTON_PROPS = {
  id: 'user-login-code-copy-button',
  icon: 'copy',
  variant: 'grey' as ButtonLinkVariant,
  size: 14,
  left: true,
  label: 'Copy URL',
};

export const COPIED_BUTTON_PROPS = {
  id: 'user-login-cod-copied-button',
  icon: 'check',
  variant: 'turquoise' as ButtonLinkVariant,
  size: 14,
  left: true,
  label: 'URL Copied',
};
